import { Accordion } from "//jp.goldwin.global/cdn/shop/t/2/assets/module-accordion.js?v=183645931558941211681789710120";
import { MySwiper } from "//jp.goldwin.global/cdn/shop/t/2/assets/module-my-swiper.js?v=91760348709481379801788165070";

function setupAccordion() {
  const footerMainNaviAccordion = new Accordion(document.getElementById("FOOTER_MAIN_NAVI"), {
    classNames: {
      open: "is-active",
    },
    selector: {
      item: ".js-accordion-item",
      trigger: ".js-accordion-trigger",
      target: ".js-accordion-target",
    },
  });
}

function getVisibleVideo(slideEl) {
  if (!slideEl) return null;

  return (
    Array.from(slideEl.querySelectorAll("video")).find(
      (video) => video.offsetParent !== null
    ) ?? null
  );
}

function setupSwiper() {
  const sliders = document.querySelectorAll(
    "[data-gw-hero-slider]"
  );

  sliders.forEach((slider) => {
    const pauseButton = slider.querySelector(
      ".swiper-pause-button"
    );

    let isPaused = false;

    // PC/SP切り替えで非表示になった動画のバックグラウンド再生を止める
    const syncVisibleVideos = () => {
      slider.querySelectorAll(".swiper-slide video").forEach((video) => {
        if (video.offsetParent === null) {
          video.pause();
        } else if (!isPaused) {
          video.play().catch(() => {
            // 自動再生が拒否された場合は何もしない
          });
        }
      });
    };

    const mySwiper = new MySwiper(slider, {
      effect: "slide",
      loop: true,
      // allowTouchMove: false,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      speed: 800,
      pagination: {
        el: slider.querySelector(".swiper-pagination"),
        type: "bullets",
      },
      slidesPerView: 1,
      on: {
        autoplayTimeLeft(swiper, timeLeft, percentage) {
          const progress = (1 - percentage).toFixed(4);

          slider.style.setProperty("--progress", progress);
        },

        slideChangeTransitionStart(swiper) {
          // 非アクティブな動画をすべて停止
          swiper.slides.forEach((slide) => {
            slide.querySelectorAll("video").forEach((video) => {
              video.play();
            });
          });
        },

        slideChangeTransitionEnd(swiper) {
          if (isPaused) return;

          const activeSlide = swiper.slides[swiper.activeIndex];
          const video = getVisibleVideo(activeSlide);

          video?.play().catch(() => {
            // 自動再生が拒否された場合は何もしない
          });
        },
      },
    });

    syncVisibleVideos();
    window.addEventListener("resize", syncVisibleVideos);

    if (!pauseButton) return;

    pauseButton.addEventListener("click", async () => {
      console.log(mySwiper.swiperMap.get(slider));
      const swiper = mySwiper.swiperMap.get(slider);

      if (!swiper?.autoplay) return;


      const activeSlide = swiper.slides[swiper.activeIndex];
      const video = getVisibleVideo(activeSlide);

      if (isPaused) {
        swiper.autoplay.resume();
        if (video) {
          try {
            await video.play();
          } catch (error) {
            console.warn("動画を再生できませんでした。", error);
          }
        }
      } else {
        swiper.autoplay.pause();
        video?.pause();
      }

      isPaused = !isPaused;

      pauseButton.classList.toggle("is-paused", isPaused);
      pauseButton.setAttribute("aria-pressed", String(isPaused));
      pauseButton.setAttribute(
        "aria-label",
        isPaused ? "スライドを再生" : "スライドを一時停止"
      );
    });
  });
}


function handleWindowReady() {
  setupAccordion();
  setupSwiper();
}

window.addEventListener('DOMContentLoaded', handleWindowReady);